// hooks/useDashboardHandler.js
import { useCallback } from 'react';
import { createSearchParams } from '../utils/helpers';

export const useDashboardHandler = ({
    categories,
    filters,
    handleFilterChange,
    fetchSpatialData,
    fethAllCompanies,
    fetchAllAlerts,
    fetchUserData,
    fetchCategories,
    saveToHistory,
    setIsLoading,
    fetchSemanticRCA2,
    setCurrentSubcategoryPrompt,
    fetchAllStatesData,
    setTotalCounts,
    setIsCategoriesLoading,
    setIsAlertsLoading,
    setIsCompaniesLoading,
    setIsStatesLoading,
    fetchAllTypeCompaniesData
}) => {
    const handleDashboardClick = useCallback(async (_, __, config) => {
        setIsLoading(true);
        try {
            let categoryData = Object.entries(categories)[config.dataPointIndex];
            console.log("categoryData", categoryData)
            if (!categoryData) return;

            handleFilterChange('query', categoryData[1].prompt);
            handleFilterChange('title', categoryData[0]);


            const data = await fetchSemanticRCA2({
                ...filters,
                query: categoryData[1].prompt,
                complaintNumbers: categoryData[1].complaintNumbers || ["NA"]
            });
            // setTotalCounts(categoryData[1].count);

            if (data.complaintNumbers && data.complaintNumbers.length > 0) {
                handleFilterChange('complaintNumbers', data.complaintNumbers || ["NA"]);
                categoryData[1].complaintNumbers = data.complaintNumbers || ["NA"];
            }

            console.log("totalCounts in usedash", categoryData[1].total_counts)

            // categoryData[1].total_counts = data.total_counts;

            const newFilters = {
                ...filters,
                query: categoryData[1].prompt,
                complaintNumbers: categoryData[1].complaintNumbers || ["NA"]
            };

            // Set granular loading states
            if (setIsCategoriesLoading) setIsCategoriesLoading(true);
            if (setIsStatesLoading) setIsStatesLoading(true);
            if (setIsCompaniesLoading) setIsCompaniesLoading(true);
            if (setIsAlertsLoading) setIsAlertsLoading(true);

            // Execute fetches in parallel where possible
            const fetchStatesPromise = fetchAllStatesData(categoryData, categoryData[1].complaintNumbers, newFilters)
                .finally(() => { if (setIsStatesLoading) setIsStatesLoading(false); });

            // const fetchCompaniesPromise = fethAllCompanies(categoryData, categoryData[1].complaintNumbers, newFilters)
            //     .finally(() => { if (setIsCompaniesLoading) setIsCompaniesLoading(false); });
            const fetchCompaniesPromise = fetchAllTypeCompaniesData(categoryData, categoryData[1].complaintNumbers, newFilters)
                .finally(() => { if (setIsCompaniesLoading) setIsCompaniesLoading(false); });

            const fetchCategoriesAndAlerts = async () => {
                try {
                    const updatedCategories = await fetchCategories(categoryData, newFilters);
                    setIsCategoriesLoading?.(false);

                    if (!updatedCategories || Object.keys(updatedCategories).length === 0) return;

                    await fetchAllAlerts(
                        categoryData[1].complaintNumbers,
                        updatedCategories,
                        newFilters
                    );
                } catch (err) {
                    console.error("Error in categories/alerts fetch:", err);
                } finally {
                    setIsCategoriesLoading?.(false);
                    setIsAlertsLoading?.(false);
                }
            };

            await Promise.all([fetchStatesPromise, fetchCompaniesPromise, fetchCategoriesAndAlerts()]);

            if (setCurrentSubcategoryPrompt) {
                setCurrentSubcategoryPrompt(categoryData[1].prompt);
            }

            const searchParams = {
                ...createSearchParams({ ...filters, query: categoryData[1].prompt, title: categoryData[0] }),
                complaint_numbers: categoryData[1].complaintNumbers || ["NA"]
            };
            searchParams.total_counts = categoryData[1].count;
            searchParams.prompt = categoryData[1].prompt;
            saveToHistory(searchParams);
        } catch (error) {
            console.error('Error handling category click:', error);
        } finally {
            setIsLoading(false);
        }
    }, [
        categories,
        filters,
        handleFilterChange,
        fetchUserData,
        fetchCategories,
        saveToHistory,
        setIsLoading,
        fethAllCompanies,
        fetchSpatialData,
        setCurrentSubcategoryPrompt,
        fetchAllAlerts,
        fetchSemanticRCA2,
        fetchAllStatesData,
        setTotalCounts,
        setIsCategoriesLoading,
        setIsAlertsLoading,
        setIsCompaniesLoading,
        setIsStatesLoading
    ]);

    return { handleDashboardClick };
};